<template>
  <div class="content">
    <div class="login-style">
      <div class="escudo">
        <img src="@/assets/escudo.webp" alt="">
      </div>


      <form @submit.prevent="login" class="acessos">
        <input
          v-model="username"
          placeholder="Usuário"
          name="user"
          autocomplete="username"
        />
        <input
          v-model="password"
          type="password"
          placeholder="Senha"
          name="password"
          autocomplete="current-password"
        />
        <button type="submit">Entrar</button>
      </form>

      <p v-if="error" class="mensagem">{{ error }}</p>

      <div class="escudo-rise">
        <img src="@/assets/rise.png" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const username = ref('')
const password = ref('')
const error = ref('')

const login = async () => {
  try {
    const res = await axios.post('https://academiarise.com/api/auth/login.php', {
      username: username.value,
      password: password.value
    })

    if (res.data.success) {
      localStorage.setItem('authToken', res.data.token || 'logado')
      localStorage.setItem('userTipo', res.data.tipo?.trim() || 'admin')
      router.push('/dashboard')
    } else {
      error.value = res.data.message || 'Usuário ou senha inválidos'
    }
  } catch (e) {
    console.error('Erro de conexão:', e)
    error.value = 'Erro na conexão com o servidor'
  }
}
</script>

<style scoped>
h2{
  margin-bottom: 10%;
  margin-top: 10%;
  font-weight: bold;
  font-size: 2rem;
  color: #f7f7f7;
}
.content{
  background-color: #00007b ;
  width: 30%;
  margin-left: auto;
  margin-right: auto;

  border-radius: 2% 2% 2%;

  align-items: center;
}

.acessos{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  height: 30vh;
  
}
input{
 padding: 10px 15px;
  border: 2px solid #ccc;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 10%;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s, box-shadow 0.3s;

}
button{
  width: 40%;
  height: 40px;
  cursor: pointer;
  background-color: #0089ff;
  border: none;
  color:#f7f7f7 ;
  border-radius: 12px;


}
button:hover{
  background-color: #082553 ;
  color: #f7f7f7;

}
.mensagem{
  margin-top: 50px;
  color: white;
  font-weight: bold;
}
.escudo,.escudo-rise{
  width: 25%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2%;
  margin-bottom: 10%;
}
.escudo-rise img{
width: 100%;
}
.escudo img{
  width: 100%;
}
</style>